import React, { ReactNode } from "react";
import { exportBatchSearchResultsToExcel } from '../../helpers/batchSearchService'
import { useTranslation } from "react-i18next";
import { logUiEvent } from "../../adapters/FrontEndUiEventAdapter";

type ExcelExportProps = {
  data: Array<SimplifiedBatchSearchResultType>
  children?: ReactNode
  disabled: boolean
  slot?:string
}

const BatchSearchExcelExportButton = ({ slot, data, children, disabled }: ExcelExportProps) => {

  const { t } = useTranslation();   
  const handleClick = async () => {
    exportBatchSearchResultsToExcel(data, t);
    await logUiEvent("ExportExcel BatchSearch");
  };

  return <button type="button" slot={slot} className='btn-export sdds-btn sdds-btn-primary sdds-btn-sm' onClick={() => { handleClick(); }} 
          disabled={disabled}>{children && children}</button>;
}

export default BatchSearchExcelExportButton;
